// src/components/ErrorBoundary.jsx
// 3.62.2 (owner, 2026-10-15): a page that fails to draw no longer leaves the
// whole portal blank (the bell bug of 3.59.2 did). People see a short message
// with Reload and Go to Overview, and the error is sent to the backend
// (/portal/client-error, routes/portal.js), which records it for Health →
// "Portal errors" and emails admin@ through the Health alerts.
import { Component } from 'react';
import { reportClientError } from '../utils/bugWatch';
import { BugForm } from './ReportBug';

export { reportClientError };   // 3.83.0: it lives in utils/bugWatch.js

export default class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null, bug: false }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    reportClientError('crash', error?.message || String(error), { where: String(info?.componentStack || '').split('\n').filter(Boolean).slice(0, 4).join(' < ').slice(0, 400) });
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" style={S.wrap}>
        <div style={S.card}>
          <div style={S.title}>Something went wrong on this page</div>
          <p style={S.text}>The page couldn't be shown. Your faxes are safe. Reload to try again; if it keeps happening, go to the Overview. Fax Portal support has been told.</p>
          <div style={S.row}>
            <button type="button" style={S.primary} onClick={() => window.location.reload()}>Reload</button>
            <button type="button" style={S.ghost} onClick={() => { window.location.href = `${process.env.PUBLIC_URL || ''}/`; }}>Go to Overview</button>
          </div>
          {!this.state.bug && <button type="button" style={{ ...S.ghost, marginTop: 10 }} onClick={() => this.setState({ bug: true })}>Report a bug</button>}
          {this.state.bug && <BugForm />}
          <details style={S.details}><summary>Details</summary><code style={S.code}>{String(this.state.error?.message || this.state.error)}</code></details>
        </div>
      </div>
    );
  }
}

// Plain colours on purpose: the theme may be what failed
const S = {
  wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, background: '#f4f7f6', fontFamily: 'DM Sans, Segoe UI, Arial, sans-serif' },
  card: { maxWidth: 520, width: '100%', background: '#ffffff', borderRadius: 14, padding: '24px 26px', boxShadow: '0 6px 24px rgba(0,0,0,0.08)', borderTop: '4px solid #00897b' },
  title: { fontSize: 20, fontWeight: 700, color: '#00695c', marginBottom: 8 },
  text: { fontSize: 14.5, lineHeight: 1.6, color: '#37474f', margin: '0 0 16px' },
  row: { display: 'flex', gap: 10, flexWrap: 'wrap' },
  primary: { padding: '9px 20px', background: '#00897b', color: '#ffffff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' },
  ghost: { padding: '9px 16px', background: '#ffffff', color: '#546e7a', border: '1.5px solid #e0e0e0', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' },
  details: { marginTop: 16, fontSize: 12, color: '#78909c' },
  code: { display: 'block', marginTop: 6, whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#b71c1c' },
};
